module.exports = __webpack_public_path__ + "3ac24662d0c0e929a18b068f351e136e.pdf";